import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { useMantineTheme, Text } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { regexNumberOnly, numberWithComma } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputComponent from "../../components/general/InputComponent";

const BarangDPBiaya = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'barangDPBiaya-1',
    })

    const [data, setData] = React.useState({
        modalShow: false,
        modalValue: '',
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = () => {
        setData(d => ({
            ...d,
            submitLoading: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_barang_dp_biaya', data.modalValue);

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_barang_dp_biaya',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false, modalShow: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(response.data.biaya_dp, response.data.biaya_dp_metode);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false,
                modalShow: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputComponent
                stateId={stateData.data.id}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateLabel={stateData.data.label}
                stateDescription={stateData.data.description}
                statePlaceHolder={stateData.data.placeholder}
                stateReadOnly={true}
                stateValue={numberWithComma(stateData.data.value)}
                stateError={stateData.data.error}
                stateStylesInput={{
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                }}
                stateIcon={<Text size='sm'>Rp</Text>}

                fnOnClick={() =>
                    setData(d => ({
                        ...d,
                        modalShow: true,
                        modalValue: stateData.data.value
                    }))}
            />

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.modalShow}
                fnHide={() => setData(d => ({ ...d, modalShow: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Uang Muka').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.submitLoading}
                fnButtonAction={submitData}
            >
                <InputComponent
                    stateId='barangDPBiayaModalInput-1'
                    stateWithAsterisk={false}
                    stateLabel=''
                    stateDescription=''
                    statePlaceHolder='Uang Muka'
                    stateReadOnly={false}
                    stateValue={numberWithComma(data.modalValue)}
                    stateError=''
                    stateIcon={<Text size='sm'>Rp</Text>}

                    fnOnChange={(e) => setData(d => ({ ...d, modalValue: regexNumberOnly(e.target.value) }))}
                />
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default BarangDPBiaya;